<template>
  <div class="card mb-3 border-0 rounded-0 bg-white">
    <div class="card-body">
      <h4 class="card-title">{{ paymentZone.pay_z_ref }}</h4>
      <h5 class="card-subtitle mb-2 text-muted">
        Date de création :
        <b v-if="paymentZone.created_at">{{
          getDate(paymentZone.created_at)
        }}</b>
        | Zone: <b>{{ paymentZone.zone_name }}</b>
      </h5>
    </div>
  </div>

  <div
    v-if="paymentZone.statut == 0"
    class="card mb-3 border-0 rounded-0 bg-white"
  >
    <div class="card-header">
      <h5 class="mb-0">Nouveaux Bons</h5>
    </div>
    <div class="card-body">
      <div class="row mb-3">
        <div
          v-if="auth.can('ADD_BP_Z')"
          class="col-md-3 d-flex align-items-center mb-2 mb-md-0"
        >
          <button
            v-if="paymentZone.statut == 0"
            class="btn btn-success"
            @click="AddNewColis"
          >
            Ajouter
          </button>
          <v-select
            v-model="users1.per_page"
            :options="[10, 50]"
            :clearable="false"
            class="me-2"
            @input="getRows1()"
          />
          <span>{{ users1.total }} entités</span>
        </div>
        <div class="col-md-9">
          <div class="d-flex justify-content-end">
            <div class="form-group mb-0">
              <div class="d-flex align-items-center">
                <input
                  placeholder="Chercher"
                  type="text"
                  v-model="users1.searchTerm"
                  @input="getRows1()"
                  class="form-control"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <vue-good-table
        :columns="columns"
        :rows="rows1"
        :select-options="{
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
          selectAllByGroup: true,
        }"
        @on-select-all="onSelectAll"
        @on-selected-rows-change="selectionChanged"
        responsive
        :search-options="{
          enabled: true,
          externalQuery: users1.searchTerm,
        }"
      >
        <template #emptystate>
          <div class="text-center">Aucune entrées correspondants trouvés</div>
        </template>
        <template v-slot:table-row="props">
          <template v-if="props.column.field === 'note_ref'">
            <b>{{ props.row.note_ref }}</b>
          </template>
          <template v-else-if="props.column.field === 'total'">
            <b>{{ props.row.total }}</b> DH
          </template>
          <template v-else-if="props.column.field === 'created_at'">
            <span class="text-nowrap" v-if="props.row.created_at">
              {{ getDate(props.row.created_at) }}
            </span>
          </template>
          <template v-else-if="props.column.field === 'zone_name'">
            <b>{{ props.row.zone_name }}</b>
          </template>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <div class="row mt-3">
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <PaginatorContent
            :pagination="users1"
            :offset="9"
            @paginate="getRows1"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="card mb-3 border-0 rounded-0 bg-white">
    <div class="card-header">
      <h3 class="mb-0">Bons Ajoutés</h3>
    </div>
    <div class="card-body">
      <div class="row mb-3">
        <div
          v-if="auth.can('ADD_BP_Z')"
          class="col-md-3 d-flex align-items-center mb-2 mb-md-0"
        >
          <button
            v-if="paymentZone.statut == 0"
            class="btn btn-danger"
            @click="RemoveNewColis"
          >
            Supprimer
          </button>
          <v-select
            v-model="users2.per_page"
            :options="[10, 50]"
            :clearable="false"
            class="me-2"
            @input="getRows2()"
          />
          <span>{{ users2.total }} entités</span>
        </div>
        <div class="col-md-9">
          <div class="d-flex justify-content-end">
            <div class="form-group mb-0">
              <div class="d-flex align-items-center">
                <input
                  placeholder="Chercher"
                  type="text"
                  @input="getRows2()"
                  v-model="users2.searchTerm"
                  class="form-control"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <vue-good-table
        :columns="columns"
        :rows="rows2"
        :select-options="{
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
          selectAllByGroup: true,
        }"
        @on-select-all="onSelectAllColis"
        @on-selected-rows-change="selectionChangedColis"
        responsive
        :search-options="{
          enabled: true,
          externalQuery: users2.searchTerm,
        }"
      >
        <template #emptystate>
          <div class="text-center">Aucune entrées correspondants trouvés</div>
        </template>
        <template v-slot:table-row="props">
          <template v-if="props.column.field === 'note_ref'">
            <b>{{ props.row.note_ref }}</b>
          </template>
          <template v-else-if="props.column.field === 'total'">
            <b>{{ props.row.total }}</b> DH
          </template>
          <template v-else-if="props.column.field === 'created_at'">
            <span class="text-nowrap" v-if="props.row.created_at">
              {{ getDate(props.row.created_at) }}
            </span>
          </template>
          <template v-else-if="props.column.field === 'zone_name'">
            <b>{{ props.row.zone_name }}</b>
          </template>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <div class="row mt-3">
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <PaginatorContent
            :pagination="users2"
            :offset="9"
            @paginate="getRows2"
          />
        </div>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import router from "@/router";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import moment from "moment";
import { defineComponent, ref, reactive } from "vue";
import { onMounted } from "vue";

export default defineComponent({
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;


    const AgenciesList = ref([]);
    const ClientsList = ref([]);
    const AgencyStockList = ref([]);
    const isLoader = ref(true);
    const searchTerm1 = ref("");
    const searchTerm2 = ref("");
    const pageLength = ref(10);
    const pageLength2 = ref(10);
    // loading:false
    const columns = [
      {
        label: "Réf",
        field: "note_ref",
      },
      {
        label: "Date de création",
        field: "created_at",
      },
      {
        label: "Zone",
        field: "zone_name",
      },
      {
        label: "Livreur",
        field: "for_name",
      },
      {
        label: "Colis",
        field: "total_parcel",
      },
      {
        label: "Total",
        field: "total",
      },
    ];

    const SelectedRows = ref([]);
    const SelectedNewRows = ref([]);

    const codeColis = ref("");
    const rows1 = ref([]);
    const rows2 = ref([]);
    const paymentZone = ref<any>({});
    const users1 = reactive({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });
    const users2 = reactive({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    const getDate = (value: string) => {
      return moment(String(value)).format("YYYY-MM-DD HH:mm");
    };


    const SearchColis = async () => {
      const data = new FormData();
      data.append("cstmr_id", String(router.currentRoute.value.params.id));
      data.append("code_colis", codeColis.value);
      isLoader.value = true;
      try {
      const res = await api.get(
        `/api/auth/SearchColisNote`,
        { params: { cstmr_id: router.currentRoute.value.params.id, code_colis: codeColis.value } }
      );
      isLoader.value = false;
      if (res.data.message === "success") {
        // handle success if needed
      } else if (res.data.message === "not exist") {
        showToast("Aucun colis. Vous ne pouvez pas l'ajouter", "error");
      }
      } catch (error) {
      showToast("Something went wrong! Please try again", "error");
      }
    };

    const onSelectAll = (params) => {
      SelectedRows.value = params.selectedRows;
    };

    const selectionChanged = (params) => {
      SelectedRows.value = params.selectedRows;
    };

    const onSelectAllColis = (params) => {
      SelectedNewRows.value = params.selectedRows;
    };

    const selectionChangedColis = (params) => {
      SelectedNewRows.value = params.selectedRows;
    };

    const getData = async () => {
      isLoader.value = true;
      try {
      const res = await api.get(`/api/auth/show_bon_pay_zone`, {
        params: { ref: router.currentRoute.value.params.refNote },
      });
      paymentZone.value = res.data.Note;
      await getRows1();
      await getRows2();
      } catch (error) {
      showToast("Erreur lors du chargement des données", "error");
      }
      isLoader.value = false;
    };

    const getRows1 = async (page = 1) => {
      try {
        users1.current_page = page;
      const res = await api.get(
        `/api/auth/payment_bons_list`,
        {
        params: {
          ref: router.currentRoute.value.params.refNote,
          searchTerm: users1.searchTerm,
          page: users1.current_page,
          per_page: users1.per_page,
        },
        }
      );
      rows1.value = res.data.users.data;
      Object.assign(users1, res.data.users);
      } catch (error) {
      showToast("Erreur lors du chargement des bons", "error");
      }
    };

    const getRows2 = async (page = 1) => {
      try {
        users2.current_page = page;
      const res = await api.get(
        `/api/auth/bons_in_note`,
        {
        params: {
          ref: router.currentRoute.value.params.refNote,
          searchTerm: users2.searchTerm,
          page: users2.current_page,
          per_page: users2.per_page,
        },
        }
      );
      rows2.value = res.data.users.data;
      Object.assign(users2, res.data.users);
      } catch (error) {
      showToast("Erreur lors du chargement des bons ajoutés", "error");
      }
    };

    const AddNewColis = async () => {
      if (SelectedRows.value.length === 0) {
      showToast("Vous ne pouvez pas ajouter à ce bon", "error");
      } else {
      const data = new FormData();
      data.append("UserID", user.id);
      data.append("notes", JSON.stringify(SelectedRows.value));
      data.append("note_ref", String(router.currentRoute.value.params.refNote));
      try {
        const res = await api.post(`/api/auth/AddBonLToBonZ`, data);
        if (res.data.message === "success") {
        showToast("Ajouté avec succès", "success");
        await getData();
        } else {
        showToast("Something went wrong! Please try again", "error");
        }
      } catch (error) {
        showToast("Something went wrong! Please try again", "error");
      }
      }
    };

    const RemoveNewColis = async () => {
      if (SelectedNewRows.value.length === 0) {
      showToast("Vous ne pouvez pas supprimer à ce bon", "error");
      } else {
      const data = new FormData();
      data.append("UserID", user.id);
      data.append("notes", JSON.stringify(SelectedNewRows.value));
      data.append("note_ref", String(router.currentRoute.value.params.refNote));
      try {
        const res = await api.post(`/api/auth/RemoveBonLFromBonZ`, data);
        if (res.data.message === "success") {
        showToast("Supprimé avec succès", "success");
        await getData();
        } else {
        showToast("Something went wrong! Please try again", "error");
        }
      } catch (error) {
        showToast("Something went wrong! Please try again", "error");
      }
      }
    };



    onMounted(() => {
      getData();
    });





    return {
      getDate,
      auth,
      user,
      AgenciesList,
      ClientsList,
      AgencyStockList,
      isLoader,
      searchTerm1,
      searchTerm2,
      pageLength,
      pageLength2,
      columns,
      SelectedRows,
      SelectedNewRows,
      codeColis,
      rows1,
      rows2,
      paymentZone,
      users1,
      users2,
      getRows1,
      getRows2,
      onSelectAll,
      selectionChanged,
      onSelectAllColis,
      selectionChangedColis,
      AddNewColis,
      RemoveNewColis,
      SearchColis,
    };
  },
});
</script>

